export const getInitialState = (): any => ({
  resourcesData: {},
  resourcesStatus: 0
});
